<template>
  <search-bar :search="search" class-btn-search="btn-primary" ref="search">
    <div class="row">
      <!-- Protocolo -->
      <div class="form-group col-md-4 col-xs-12">
        <meta-text
          id="protocolo"
          name="protocolo"
          label="Protocolo:"
          v-model="search.protocolo"
        ></meta-text>
      </div>
      <!-- Criado Por -->
      <div class="form-group col-md-4 col-xs-12">
        <meta-text
          id="nome"
          name="nome"
          label="Criado Por:"
          v-model="search.criado_por"
        ></meta-text>
      </div>
       <!-- Relação -->
      <div class="form-group col-md-4 col-xs-12">
        <meta-select
          id="relacao"
          label="Relação:"
          name="relacao"
          v-model="relacao"
          attr-id="id"
          attr-label="relacao"
          :options="relacoes"
          deselect-label="Remover"
          select-label="Selecionar"
        ></meta-select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-4 col-xs-12">
        <meta-select
          id="status"
          label="Status:"
          name="status"
          v-model="status"
          attr-id="id"
          attr-label="status"
          :options="statusArray"
          deselect-label="Remover"
          select-label="Selecionar"
        ></meta-select>
      </div>
      <div class="form-group col-md-4 col-xs-12">
        <meta-select
          id="tipo-denuncia"
          label="Tipo de denúncia:"
          name="tipo-denuncia"
          v-model="tipo"
          attr-id="id"
          attr-label="tipo"
          :options="tiposArray"
          deselect-label="Remover"
          select-label="Selecionar"
        ></meta-select>
      </div>
    </div>

  </search-bar>
</template>

<style lang="scss">
  #nome, #protocolo {
    height: 40px !important;
  }
</style>


<script>
  import { SearchBar } from 'metawesome-datatable'
  import MetaSelect from 'meta-select'
  import MetaText from 'meta-text'

  export default {
    components: {
      SearchBar,
      MetaSelect,
      MetaText,
    },

    data() {
      return {
        search: {
          criado_por: '',
          protocolo: '',
          relacao: '',
          status: '',
          tipo: '',
        },
        relacoes: [],
        relacao: null,
        statusArray: [],
        tiposArray: [],
        status: null,
        tipo: null,
      };
    },

    watch: {
      relacao() {
        if (this.relacao && this.relacao.id) {
          this.search.relacao = this.relacao.relacao;

          return;
        }

        this.search.relacao = '';
      },

      status() {
        if (this.status && this.status.id) {
          this.search.status = this.status.status;

          return;
        }

        this.search.status = '';
      },

      tipo() {
        if (this.tipo) {
          this.search.tipo = this.tipo.tipo;
          return;
        }

        this.search.tipo = '';
      },
    },

    methods: {
      buscarRelacoes(){
        this.$parent.loading = true;
        this.$http.get('/relacoes')
        .then(({data: response}) => {
          this.relacoes = response;
        })
        .catch((e) => {
          return this.customAlert(
            'Ocorreu um erro!',
            'Entre em contato com o administrador do sistema.',
            'error',
          );
        })
        .finally(() => this.$parent.loading = false);
      },

      buscarStatus(){
        this.$parent.loading = true;
        this.$http.get('/status')
        .then(({data: response}) => {
          this.statusArray = response.reverse();
        })
        .catch ((e) => {
          return this.customAlert(
            'Ocorreu um erro!',
            'Entre em contato com o administrador do sistema.',
            'error',
          );
        })
        .finally(() => this.$parent.loading = false);
      },

      buscarTipos(){
        this.$parent.loading = true;
        this.$http.get('/denuncia/tipos')
        .then(({data: response}) => {
          this.tiposArray = response;
          this.tiposArray.push({id: null, tipo: 'Sem classificação'})
        })
        .catch((e) => {
          return this.customAlert(
            'Ocorreu um erro!',
            'Entre em contato com o administrador do sistema.',
            'error',
          );
        })
        .finally(() => this.$parent.loading = false);
      }
    },

    mounted() {
      this.buscarRelacoes();
      this.buscarStatus();
      this.buscarTipos();

      this.$refs.search.$on('filter-set', (filter) => {
        this.$emit('filter-set', filter);
      });
    },

  };
</script>



// WEBPACK FOOTER //
// src/components/SearchBar.vue